import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class OverlayService {
    open: EventEmitter<any> = new EventEmitter();
    close: EventEmitter<any> = new EventEmitter();
    constructor() { }
}
